import {AxiosError} from 'axios';
import {combine, sample} from 'effector';

import {createGate} from 'effector-react';

import i18next from 'i18next';
import {toast} from 'react-toastify';

import {showRestError} from '@app/errors';
import {rootDomain} from '@app/model';
import {SetPasswordRequest} from '@entities/password/types';

import * as api from './api';

const domain = rootDomain.createDomain('passwordDomain');
export const PasswordGate = createGate('PasswordGate');

export const setFx = domain.createEffect({handler: api.set});
export const resetFx = domain.createEffect({handler: api.set});

export const resetRequestFx = domain.createEffect({handler: api.resetRequest});
export const resetByAdminRequestFx = domain.createEffect({handler: api.resetAdminRequest});

export const changeFx = domain.createEffect({handler: api.change});

export const resetPasswordByAdminEvent = domain.createEvent<SetPasswordRequest>();

// export const setPasswordResetUser = domain.createEvent<SetPasswordRequest | null>();
// export const userForPasswordReset$ = domain
//     .createStore<SetPasswordRequest | null>(null)
//     .on(setPasswordResetUser, (_, user) => user)
//     .reset(resetAdminRequestFx.pending);

export const setExpired = domain.createEvent<boolean>();

export const error$ = domain
    .createStore<string | null>(null)
    .on(setFx.failData, (_, error) => {
        if ((error as AxiosError).status === 405) {
            toast.error(i18next.t('password.set.expired.title'));
            setExpired(true);
        } else showRestError(error);
    })
    .reset([setFx.done, PasswordGate.close]);

export const success$ = domain
    .createStore<boolean>(false)
    .on([setFx.done, resetFx.done, resetRequestFx.doneData], () => true)
    .reset([setFx, PasswordGate.close]);

export const expired$ = domain
    .createStore<boolean>(false)
    .on(setExpired, (_, state) => state)
    .reset([PasswordGate.close]);

sample({
    clock: resetPasswordByAdminEvent,
    target: resetByAdminRequestFx,
});

[resetFx, resetRequestFx, resetByAdminRequestFx, changeFx].forEach((fx) =>
    fx.failData.watch(showRestError),
);

setFx.doneData.watch(() => toast.success(i18next.t('password.set.messages.success')));
resetFx.doneData.watch(() => toast.success(i18next.t('password.reset.messages.success')));
resetByAdminRequestFx.doneData.watch(() =>
    toast.success(i18next.t('password.reset.messages.resetByAdmin')),
);
changeFx.doneData.watch(() => toast.success(i18next.t('password.change.messages.success')));

const passwordState$ = combine({
    error: error$,
    success: success$,
    expired: expired$,
    pending: combine(
        [
            setFx.pending,
            resetFx.pending,
            resetRequestFx.pending,
            resetByAdminRequestFx.pending,
            changeFx.pending,
        ],
        (pendingList) => pendingList.some(Boolean),
    ),
});

export const passwordModel = {
    state: passwordState$,
    set: setFx,
    reset: resetFx,
    resetRequest: resetRequestFx,
    change: changeFx,
};
